module.exports = __webpack_public_path__ + "img/ff-logo-footer.2d826e9.svg";